export const countries = [
    { label: "Bahrain", phone: "+973", code: "BH" },
    { label: "Kuwait", phone: "+965", code: "KW" },
    { label: "Oman", phone: "+968", code: "OM" },
    { label: "Qatar", phone: "+974", code: "QA" },
    { label: "Saudi Arabia", phone: "+966", code: "SA" },
    { label: "United Arab Emirates (UAE)", phone: "+971", code: "AE" },
];
